import React from 'react';
import { List } from 'antd';
import { get, isEmpty } from 'lodash';
import { Retry } from '@components/common';
import { SectionWrapper, StyledMoreDrawer } from '../styled';
import { StyledList } from './styled';
import Row from './Row';
import { useFetchSummary, useOpenSummary } from './hooks';
import { SkeletonLoader, More } from '../Common';
import { getEndTime } from './utils';

const PREVIEW_LIMIT = 2;
const MAX_LIMIT = 100;

const voidFn = () => null;

function Insights({ openMore = voidFn, closeMore = voidFn, showMore = true }) {
  const to = getEndTime('hour');
  const limit = showMore ? PREVIEW_LIMIT : MAX_LIMIT;

  const {
    isLoading,
    isFetching,
    isError,
    data,
    refetch,
  } = useFetchSummary({ to });

  const { brokenAssets = [] } = get(data, 'data.response.brokenAssetsData', {});
  const count = brokenAssets.length;
  const slicedbrokenAssets = brokenAssets.slice(0, limit);
  const openSummary = useOpenSummary({ closeMore });

  return (
    <SectionWrapper>
      <Retry
        isLoading={isLoading || isFetching}
        showError={isError}
        isEmpty={isEmpty(brokenAssets)}
        mountChildAlways={false}
        fetchData={refetch}
        LoadingLayer={SkeletonLoader}
      >
        <StyledList
          itemLayout="horizontal"
          split={false}
          footer={showMore ? <More count={count - slicedbrokenAssets.length} onClick={openMore} /> : null}
        >
          {slicedbrokenAssets.map((row: any, i: React.Key | null | undefined) => (
            <List.Item key={i}>
              <Row data={row} openSummary={openSummary} />
            </List.Item>
          ))}
        </StyledList>
      </Retry>
    </SectionWrapper>
  );
}

function MoreDrawer({ closeMore, visible }) {
  return (
    <StyledMoreDrawer
      title="Broken Assets"
      placement="right"
      closable
      onClose={closeMore}
      visible={visible}
      key="alert-insights-drawer"
      mask
      width={400}
      // destroyOnClose={true}
    >
      <Insights showMore={false} closeMore={closeMore} />
    </StyledMoreDrawer>
  );
}

export { Insights, MoreDrawer };
